import {GivenAnswer} from 'iterfaces/given-answer';
import {Answer} from 'iterfaces/survey';

export const mapGivenAnswersToAnswersId = (
    givenAnswers: GivenAnswer[],
): Answer['id'][] => givenAnswers.map((givenAnswer) => givenAnswer.answer.id);
